import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'qs';
import { Form, Spin } from 'antd';
import { set, get, PATH } from 'Src/storage';
import Background from 'Src/components/Background';
import Layout from 'Src/components/Layout';
import Step from 'Src/components/Step';
import { updateStep, apiClearError } from 'Src/actions';

import './index.module.less';

const getSearchParam = (location) => {
  const { search } = location;
  const searchObj = qs.parse(search, { ignoreQueryPrefix: true });
  const { step } = searchObj;
  return step;
};

const restore = (location) => {
  const step = getSearchParam(location);

  if (step) {
    const storedPathStr = get(PATH) || '[]';
    const storedPath = JSON.parse(storedPathStr);
    return storedPath;
  }
  return [];
};

const Pager = ({
  form,
  location,
  steps = [],
  version,
}) => {
  const defaultPath = restore(location);
  const [isLoading, setLoading] = useState(false);
  const [path, setPath] = useState(defaultPath);
  const currentStep = useSelector(state => state.pager.step);
  const apiError = useSelector(state => state.api.error);
  const dispatch = useDispatch();

  const setStep = useCallback(step => dispatch(updateStep(step)), [dispatch]);
  const clearError = useCallback(() => dispatch(apiClearError()), [dispatch]);

  const pathLength = path.length;
  const lastPathIndex = pathLength ? (pathLength - 1) : 0;
  const { [lastPathIndex]: lastDelta = 0 } = path;

  const onStepClick = (index) => {
    if (currentStep !== index && currentStep > index) {
      setStep(index);
    }
    return false;
  };

  const handleBack = () => {
    const newPath = [...path];
    newPath.splice(-1, 1);
    const newStep = currentStep - lastDelta;
    clearError();
    setStep(newStep);
    setPath(newPath);
    set(PATH, JSON.stringify(newPath));
  };

  const handleNext = (delta = 1) => {
    if (apiError) {
      return;
    }

    const step = getSearchParam(location);
    if (step) {
      window.history.replaceState(null, '', '/');
    }
    const newCurrentStep = currentStep + delta;
    setStep(newCurrentStep);
    const newPath = [...path, delta];
    setPath(newPath);
    set(PATH, JSON.stringify(newPath));
  };

  const rSteps = steps.map((step, index) => {
    const { Component, name } = step;
    const isActive = currentStep === index;
    const isOpened = currentStep <= index;
    const isPassed = currentStep < index;
    const isVisiblePrevious = (currentStep > 0 && lastDelta > 0 && index === currentStep - lastDelta);
    const isInvisiblePrevious = (currentStep > 1 && index < currentStep - lastDelta);
    const isSkipped = (index < currentStep && index > currentStep - lastDelta);
    const isInFuture = index > currentStep;
    return (
      <Step
        isActive={isActive}
        isFirst={index < 2}
        isHiddenBottom={isInFuture || isSkipped}
        isInvisiblePrevious={isInvisiblePrevious}
        isVisiblePrevious={isVisiblePrevious}
        key={index}
        name={name}
        onBack={handleBack}
        onClick={() => onStepClick(index)}
      >
        <Component
          key={index}
          form={form}
          onNext={handleNext}
          isActive={isActive}
          isOpened={isOpened}
          isPassed={isPassed}
          onLoading={setLoading}
        />
      </Step>
    );
  });

  const formComp = (
    <Form
      layout="vertical"
      className="h-100 overflow-auto"
    >
      {rSteps}
    </Form>
  );

  const page = formComp;

  return (
    <Spin
      spinning={isLoading}
      size="large"
      style={{ maxHeight: 'unset' }}
    >
      <Layout className="version">
        <Background />
        {page}
      </Layout>
    </Spin>
  );
};

const withForm = Form.create({ name: 'onboarding' })(Pager);

export default withForm;
